<div class="container">
  <h1
    *ngIf="!estInscrit"
    [innerHTML]="'gestionUtilisateur.titreh1un' | translate"></h1>
  <h1
    *ngIf="estInscrit"
    [innerHTML]="'gestionUtilisateur.titreh1deux' | translate"></h1>

  <div class="text"
    *ngIf="!estInscrit"
    id="texteCreer"
    [innerHTML]="'gestionUtilisateur.texteCreer' | translate"></div>
  <div class="text"
    *ngIf="estInscrit"
    id="texteModifier"
    [innerHTML]="'gestionUtilisateur.texteModifier' | translate"></div>
  <br>
  <br>
  <br>
  <div class="row">
    <div class="col-12 col-lg-8">
      <form [formGroup]="formulaire">
        <!--********************Champs verrouillés**********************-->
        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12 mb-label">
            <label class="control-label mb-label">{{ 'gestionUtilisateur.form.nom' | translate }}</label>
            <div class="mb-input-text text">{{ nomPrenom }}</div>
          </div>
        </div>

        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12">
            <label class="control-label mb-label">{{ 'gestionUtilisateur.form.courriel' | translate }}</label>
            <div class="mb-input-text text">{{ formulaire.value.courriel }}</div>
          </div>
        </div>

        <!--********************Champs visibles et modifiables**********************-->
        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12">
            <label for="noTel"
              class="control-label mb-label">
              {{ 'gestionUtilisateur.form.numeroDeTelephone' | translate }}
              <span class="champObligatoire">*</span>
            </label>

            <input type="text"
              id="noTel"
              formControlName="numeroTelephone"
              class="form-control form-control-gl mb-input-text lg-InputText"
              [placeholder]="telephonePlaceholder"
              [mask]="masqueNumeroTelephone" />

            <div class="messageerreur"
              *ngIf="(formulaire.get('numeroTelephone')?.touched || formulaire.get('numeroTelephone')?.dirty) && !formulaire.get('numeroTelephone')?.valid">
              <span *ngIf="formulaire.get('numeroTelephone').errors?.['required']">{{ erreurTelephoneRequired }}</span>
              <span *ngIf="formulaire.get('numeroTelephone').errors?.['pattern']">{{ erreurTelephoneInvalid }}</span>
            </div>
          </div>
        </div>

        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12">
            <label for="noPosteTel"
              class="control-label mb-label">
              {{ 'gestionUtilisateur.form.numeroDuPoste' | translate }}
            </label>

            <input type="text"
              id="noPosteTel"
              formControlName="numeroPoste"
              class="form-control form-control-gl mb-input-text lg-InputText"
              (keypress)="chiffreUniquement($event)" />

            <div class="messageerreur"
              *ngIf="(formulaire.get('numeroPoste')?.touched || formulaire.get('numeroPoste')?.dirty) && !formulaire.get('numeroPoste')?.valid">
              <span *ngIf="formulaire.get('numeroPoste').errors?.['maxlength']">Maximum de 10 caractères.</span>
            </div>
          </div>
        </div>

        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12">
            <label for="typeInter"
              class="control-label mb-label">
              {{ 'gestionUtilisateur.form.typeDemployeur' | translate }}
              <span class="champObligatoire"
                *ngIf="utilisateurCourant?.id === -1 || typeEmployeur === ''">*</span>
            </label>

            <select *ngIf="utilisateurCourant?.id === -1"
              id="typeInter"
              formControlName="typeIntervenant"
              form="formulaire"
              class="form-control form-control-gl mb-input-text lg-InputText">
              <option value="">--Sélectionner--</option>
              <option *ngFor="let typeInter of listeTypeInter"
                [value]=typeInter.valeur>{{typeInter.description}}</option>
            </select>

            <div class="messageerreur"
              *ngIf="(formulaire.get('typeIntervenant')?.touched || formulaire.get('typeIntervenant')?.dirty) && !formulaire.get('typeIntervenant')?.valid">
              <span *ngIf="formulaire.get('typeIntervenant').errors?.['required']">
                {{ erreurTypeClienteleExterneRequired }}
              </span>
            </div>

            <div class="mb-input-text text"
              *ngIf="utilisateurCourant?.id !== -1">{{typeEmployeur}}</div>
          </div>
        </div>

        <div class="row mb-div-labelInputText">
          <div class="col-sm-6 col-12">
            <label for="nomMinisOrga"
              class="control-label mb-label">
              {{ 'gestionUtilisateur.form.nomDeEmployeur' | translate }}
              <span class="champObligatoire"
                *ngIf="utilisateurCourant?.id === -1 || utilisateurCourant?.nomMinistereOrganisme === '' || utilisateurCourant?.nomMinistereOrganisme === null || utilisateurCourant?.nomMinistereOrganisme === undefined">*</span>
            </label>

            <input *ngIf="utilisateurCourant?.id === -1"
              type="text"
              id="nomMinisOrga"
              formControlName="nomMinistereOrganisme"
              class="form-control form-control-gl mb-input-text lg-InputText" />
            <div class="mb-input-text text"
              *ngIf="utilisateurCourant?.id !== -1">{{utilisateurCourant?.nomMinistereOrganisme}}</div>

            <div class="messageerreur"
              *ngIf="(formulaire.get('nomMinistereOrganisme')?.touched || formulaire.get('nomMinistereOrganisme')?.dirty) && !formulaire.get('nomMinistereOrganisme')?.valid">
              <span *ngIf="formulaire.get('nomMinistereOrganisme').errors?.['required']">{{ erreurNomEmployeurRequired
                }} </span>
              <span *ngIf="formulaire.get('nomMinistereOrganisme').errors?.['maxlength']">{{ erreurNomEmployeurMaxLength
                }}</span>
            </div>
          </div>
        </div>

        <div class="d-grid gap-2 d-flex d-md-flex">
          <button class="btn btn-secondary"
            type="button"
            (click)="reinitialiserForm()">{{ 'sigt.global.boutons.reinitialiser' | translate }}</button>
          <button class="btn btn-primary"
            type="submit"
            [disabled]="!formulaire.valid"
            (click)="enregistrerForm()">{{ 'sigt.global.boutons.enregistrer' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div>
<zzz-piv-piedpage></zzz-piv-piedpage>
